import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	forgeRetryButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	forgeRetryButton: {
		id: 'forge-field-base.form.field-message.field-dispatch-button.forge-retry-button',
		defaultMessage: 'Try again?',
		description: 'Message shown on button to retry action of retriving Forge custom field value.',
	},
});
export default messages;
